export const toggle = (opened) => ({
  type: 'TOGGLED',
  payload: opened,
});

export const toOpen = () => ({
  type: 'OPENED',
  payload: true,
});

export const toClose = () => ({
  type: 'CLOSED',
  payload: false,
});
